@let fetchedAt = $paymentsFetchedAt | async; @let payments = $payments | async;

<mat-card class="payment-card">
  @if (fetchedAt) {
  <mat-card-content>
    <table mat-table [dataSource]="payments ?? []">
      <ng-container matColumnDef="netCashPaymentId">
        <th mat-header-cell *matHeaderCellDef>Net Cash Payment Id</th>
        <td mat-cell *matCellDef="let element">
          {{ element.netCashPaymentId }}
        </td>
      </ng-container>

      <ng-container matColumnDef="batchName">
        <th mat-header-cell *matHeaderCellDef>Batch Name</th>
        <td mat-cell *matCellDef="let element">{{ element.batchName }}</td>
      </ng-container>

      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef>Total</th>
        <td mat-cell *matCellDef="let element">
          {{ element.total | currency : "R" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          <div class="centered-vertically">
            <mat-icon [ngClass]="isPaid(element) ? 'green' : 'red'">
              {{ isPaid(element) ? "check_circle" : "cancel" }}
            </mat-icon>
            <span class="small-light-grey">
              {{ this.getStatusText(element) }}
            </span>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr
        mat-row
        (click)="navToPaymentDetails(row.id)"
        *matRowDef="let row; columns: columns"
      ></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell p-2" [attr.colspan]="columns.length">
          No Payments
        </td>
      </tr>
    </table>
  </mat-card-content>
  } @else {
  <div class="my-3 d-flex justify-content-center">
    <mat-progress-spinner
      diameter="30"
      mode="indeterminate"
      color="primary"
    ></mat-progress-spinner>
  </div>
  } @if (paymentsDisabled) {
  <div class="overlay">
    <span>payments have been disabled</span>
  </div>
  }
</mat-card>
